// @flow

import React, { useState, useEffect } from "react";
import { localize } from "redux-i18n";
import type { FormProps } from "redux-form";
import { Button, Checkbox, View } from "@components";

type Props = $Exact<{
  ...PropsFromLocalize,
  ...$Exact<FormProps>, // https://stackoverflow.com/a/44771268/220839
}>;

export function CoronaAbsencesFilter(props: Props) {
  const { reasons } = props;

  const [filters, setFilters] = useState([]);

  useEffect(() => {
    setFilters(_ => reasons.map(reason => reason.id));
  }, [reasons.length]);

  function onChange(id: string) {
    return function(isChecked: string) {
      let newArray = [];
      if (isChecked === "true") {
        newArray = [...filters, id];
      } else {
        newArray = filters.toSpliced(filters.indexOf(id), 1);
      }
      setFilters(_ => newArray);
    };
  }

  function changeAll(isChecked: string) {
    setFilters(_ => (isChecked === "true" ? reasons.map(r => r.id) : []));
  }

  function onSubmit() {
    props.onSubmit(filters);
  }

  return (
    <View direction="row" justifyContent="space-between">
      <View className="flex-wrap" gap={2} direction="row">
        <Checkbox
          id={"all"}
          className="mr-3 mb-0"
          onChange={changeAll}
          checked={filters.length === reasons.length}
          label={props.t("ALL")}
        />
        {reasons.map(reason => {
          return (
            <Checkbox
              key={reason.id}
              className="mr-3 mb-0"
              onChange={onChange(reason.id)}
              id={reason.id}
              checked={filters.indexOf(reason.id) >= 0}
              label={reason.label}
            />
          );
        })}
      </View>
      <View direction="row">
        <Button
          onClick={onSubmit}
          disabled={filters.length < 1}
          className="small"
          materialIcon="replay_circle_filled"
        >
          {props.t("SUBMIT")}
        </Button>
      </View>
    </View>
  );
}

export default localize()(CoronaAbsencesFilter);
